<template>
  <b-modal v-model="visible" :title="$t('Webportal.Actions.InquiryWizard.Draft.ResumeTitle')" ok-only :ok-title="$t('Webportal.Close')" ok-variant="secondary" size="lg" :ok-disabled="resumingDraftId !== null" :no-close-on-backdrop="resumingDraftId !== null" :no-close-on-esc="resumingDraftId !== null" :hide-header-close="resumingDraftId !== null">
    <p class="text-muted mb-3">
      {{ $t('Webportal.Actions.InquiryWizard.Draft.ResumeDescription') }}
      <span class="text-muted small">({{ $t('Webportal.Actions.InquiryWizard.DeadlineHint') }})</span>
    </p>

    <div v-if="isDraftLoading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>

    <b-list-group v-else-if="draftItems.length > 0">
      <b-list-group-item
        v-for="draft in draftItems"
        :key="draft.SurveyRevisionDraftId"
        button
        :disabled="resumingDraftId !== null"
        class="d-flex justify-content-between align-items-center"
        @click="resumeDraft(draft)"
      >
        <div>
          <strong>{{ draft.ExternalSurveyInstanceId }}</strong>
          <span v-if="draft.ClientLocationName">– {{ draft.ClientLocationName }}</span>
          <span v-if="draft.RevisionMaxDate"> ({{ draft.RevisionMaxDate | msm_date }}) </span>
          <br />
          <small class="text-muted">{{ $t('Webportal.Actions.InquiryWizard.Draft.SavedAt') }} {{ draft.CreatedAt | msm_datetime }}</small>
        </div>
        <b-spinner v-if="resumingDraftId === draft.SurveyRevisionDraftId" small variant="primary" />
        <font-awesome-icon v-else :icon="['fal', 'chevron-right']" />
      </b-list-group-item>
    </b-list-group>

    <b-alert v-else show variant="info">{{ $t('Webportal.Actions.InquiryWizard.Draft.NoDrafts') }}</b-alert>
  </b-modal>
</template>

<script>
import ActionService from '@/services/ActionService';

export default {
  name: "ResumeDraftDialog",

  props: {
    draftItems: {
      type: Array,
      default: () => [],
    },
    isDraftLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      visible: false,
      resumingDraftId: null,
    };
  },

  methods: {
    show() {
      this.visible = true;
    },

    hide() {
      this.visible = false;
    },

    async resumeDraft(draft) {
      if (this.resumingDraftId !== null) return;
      this.resumingDraftId = draft.SurveyRevisionDraftId;
      try {
        const response = await ActionService.getSurveyRevisionDraft(draft.SurveyRevisionDraftId);
        const draftData = response.data;

        if (!draftData || !draftData.Content) {
          this.$bvToast.toast(this.$t('Webportal.Actions.InquiryWizard.Draft.LoadError'), { title: this.$t('Webportal.Error'), variant: 'danger' });
          return;
        }

        await this.$store.dispatch('inquiryWizard/restoreFromDraft', draftData.Content);

        try {
          await ActionService.deleteSurveyRevisionDraft(draft.SurveyRevisionDraftId);
        } catch (deleteError) {
          console.warn('Failed to delete draft after restore:', deleteError);
        }

        this.hide();
        this.$router.push({ name: 'InquiryWizard' });
      } catch (error) {
        this.$bvToast.toast(this.$t('Webportal.Actions.InquiryWizard.Draft.ResumeError'), { title: this.$t('Webportal.Error'), variant: 'danger' });
      } finally {
        this.resumingDraftId = null;
      }
    },
  },
};
</script>
